var _a, _b;
import { writable } from "svelte/store";
import { mdiWeatherNight, mdiWeatherSunny } from '@mdi/js';
const storedTheme = (_a = localStorage.getItem("theme")) !== null && _a !== void 0 ? _a : 'light';
const storedEncoding = (_b = localStorage.getItem("encoding")) !== null && _b !== void 0 ? _b : 'base64';
export const theme = writable(storedTheme);
export const themeIcon = storedTheme === 'dark' ? mdiWeatherSunny : mdiWeatherNight;
export const encodingDefault = writable(storedEncoding);
theme.subscribe(value => {
    localStorage.setItem("theme", value === 'dark' ? 'dark' : 'light');
});
encodingDefault.subscribe(value => {
    localStorage.setItem("encoding", value === 'hex' ? 'hex' : 'base64');
});
